import DeleteIcon from "@mui/icons-material/Delete";

export const Icons = {
  DeleteIcon,
};
